import { useBehaviorSubject } from '../../../hooks';
import type { UseBlotterTableProps } from './types';

/**
 * Helper hook to create the data and error observables for useBlotterTable.
 * - For pinned row data, use pinnedTopRowData and pinnedBottomRowData out of gridOptions.
 *
 * @param data - The data array. Should be memoized to prevent unnecessary observable emissions.
 * @param errorMessage - Optional error message string to show on the blotter.
 */
export const useBlotterObservables = <T>({
  data,
  errorMessage,
}: {
  data: T[];
  errorMessage?: string | null;
}): {
  dataObservable: UseBlotterTableProps<T>['dataObservable'];
  errorObservable?: UseBlotterTableProps<T>['errorObservable'];
} => {
  const { observable: dataObservable } = useBehaviorSubject(() => ({ initial: true, data }), [data]);
  const { observable: errorObservable } = useBehaviorSubject(
    () => ({ error: errorMessage ? { msg: errorMessage } : undefined }),
    [errorMessage]
  );

  return {
    dataObservable,
    errorObservable,
  };
};
